import { oc } from '@orpc/contract';
import { closeNoDealInputSchema, estimateDetailSchema } from '../schemas/estimates.schemas.js';
/** A recorded outcome, not a deletion: the estimate stays searchable for ever (plan §3.1). */
export const closeEstimateNoDealContract = oc
    .route({
    method: 'POST',
    path: '/estimates/{estimateId}/no-deal',
    tags: ['Estimates'],
    summary: 'Close the estimate as no deal',
})
    .input(closeNoDealInputSchema)
    .output(estimateDetailSchema);
//# sourceMappingURL=close-estimate-no-deal.contract.js.map